// REACT
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

// COMPONENTS
import Loader from "components/shared/loader";
import FormWrapper from "components/Form/form-wrapper";
import ModalWrapperBtn from "components/shared/modal-wrapper-btn";
import EditApplicationWrapper from "./EditApplication";
import ApplicationsKeys from "./ApplicationsKeys";
import ApplicationPrivileges from "./ApplicationPrivileges";
import AppSnippets from "./AppSnippets";
import AppSettings from "./AppSettings";
import ApplicationAlerts from "./ApplicationAlerts";
import TrustedAddresses from "./TrustedAddresses";

// STORE ACTIONS
import { getApplication } from "store/actions";

// HELPER FUNCTIONS
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { handleErrMsg } from "helpers/functions";

// REACT BOOTSTRAP
import { Col, Nav, Row, Tab } from "react-bootstrap";

// STYLES
import styles from "./styles/style.module.scss";
import DemoStores from "pages/demo-stores/main";
import Subscriptions from "pages/subscriptions";
import Webhooks from "pages/webhooks/main";
import CustomPlans from "pages/application-custom-plans/main";

const EditApplication = () => {
    const { formatMessage, locale } = useIntl();
    const dispatch = useDispatch();
    const { applicationId } = useParams();
    const navigate = useNavigate();
    const { loading, error, singleApplication } = useSelector(
        (state) => state.applications
    );

    console.log(singleApplication);
    useEffect(() => {
        dispatch(getApplication(applicationId));
    }, [dispatch, applicationId]);

    // error
    useEffect(() => {
        if (Object.keys(error)?.length > 0) {
            toastErrorMessage(
                formatMessage({ id: handleErrMsg(error) }),
                locale
            );
        }
    }, [error, formatMessage, locale, navigate]);

    if (loading) return <Loader />;

    return (
        <>
            <div className={styles["applications-edit"]}>
                <FormWrapper title={singleApplication?.name?.[locale]} lg={12}>
                    <Tab.Container defaultActiveKey="editApplication">
                        <Nav>
                            <Nav.Item>
                                <Nav.Link eventKey="editApplication">
                                    <FormattedMessage id="editApplication" />{" "}
                                    <i></i>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="demoStores">
                                    <FormattedMessage id="demoStores" />{" "}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="subscriptions">
                                    <FormattedMessage id="subscriptions" />{" "}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="webhooks">
                                    <FormattedMessage id="webhooks" />{" "}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="customPlans">
                                    <FormattedMessage id="customPlans" />{" "}
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content>
                            <Tab.Pane eventKey="editApplication">
                                <Row>
                                    <Col lg={12}>
                                        <EditApplicationWrapper />
                                    </Col>
                                    <Col lg={12}>
                                        <ApplicationsKeys />
                                    </Col>
                                    <Col lg={12}>
                                        <ApplicationPrivileges />
                                    </Col>
                                    <Col lg={12}>
                                        <ApplicationAlerts />
                                    </Col>
                                    <Col xs={12}>
                                        <TrustedAddresses />
                                    </Col>
                                    <Col xs={12}>
                                        <AppSettings />
                                    </Col>
                                    <Col xs={12}>
                                        <AppSnippets />
                                    </Col>
                                    <Col xs={12}>
                                        <Col xs="12">
                                            <ModalWrapperBtn
                                                title={
                                                    <FormattedMessage id="publishRequest" />
                                                }
                                                btnText={
                                                    <FormattedMessage id="publishRequest" />
                                                }
                                                handleSave={() =>
                                                    navigate(
                                                        "/identityVerification"
                                                    )
                                                }
                                            >
                                                <div className="">
                                                    <label className="">
                                                        <FormattedMessage id="confirmAppPublishRequest" />
                                                    </label>
                                                </div>
                                            </ModalWrapperBtn>
                                        </Col>
                                    </Col>
                                </Row>
                            </Tab.Pane>
                            <Tab.Pane eventKey="demoStores">
                                <DemoStores invertControl={true} />
                            </Tab.Pane>
                            <Tab.Pane eventKey="subscriptions">
                                <Subscriptions />
                            </Tab.Pane>
                            <Tab.Pane eventKey="webhooks">
                                <Webhooks />
                            </Tab.Pane>
                            <Tab.Pane eventKey="customPlans">
                                <CustomPlans />
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </FormWrapper>
            </div>
        </>
    );
};

export default EditApplication;
